<template>
  <v-dialog width="450px" v-model="viewMenu" presistent>
    <v-card class="pa-5">
        <v-progress-circular
        :size="70"
        color="blue"
        indeterminate
        ></v-progress-circular>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    data(){
        return{
        }
    },
    computed: {
        viewMenu: {
            get() { return this.$store.getters.pending },   
        },
    },
    methods: {
    },
}
</script>


